import { buildTime, version, sourceUrl } from "./version";
import { Environment } from "./environment.interface";

export const environment: Environment = {
    production: false,
    assets: "assets",
    baseUrl: "http://127.0.0.1:8000",
    buildTime,
    version,
    sourceUrl,
    matomo: {
        siteId: '18',
        trackerUrl: 'https://matomo.hum.uu.nl/',
    },

};